import { InputLabel, MenuItem } from '@mui/material';
import { memo, useMemo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';
interface PaymentListComponentProps {
  disabled?: boolean;
  value: string;
  onChange: (acronym?: string) => void;
  error?: boolean;
  label?: string;
  id?: string;
  isForEditPage?: boolean;
  documentType?: string;
}

const Payments = Object.freeze([
  {
    id: 'C',
    value: 'Contanti',
  },
  {
    id: 'P',
    value: 'POS',
  },
  {
    id: 'E',
    value: 'Esente',
  },
]);

const PaymentListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Pagamento',
  id = 'payment-list',
}: PaymentListComponentProps): React.ReactElement => {
  const newList = useMemo(() => {
    const list = (Payments as Array<ItemVM>) || [];
    return list;
  }, []);

  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {label}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value}
        label={label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        {newList?.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

PaymentListComponent.displayName = 'Payment List component for cash-check page';

const PaymentList = memo(PaymentListComponent);

export default PaymentList as typeof PaymentListComponent;
